import { BattleshipGenerator } from './battleship-generator';
import { GridData, CardData, Team, Coordinates } from './types';
import remove from 'lodash/remove';

export function generateGridData(nColumns: number, nRows: number): GridData[] {
    const gridData: GridData[] = [];
    for (let col = 0; col < nColumns; col++) {
        const colCardData: CardData[] = [];
        for (let row = 0; row < nRows; row++) {
            colCardData.push({
                locationCode: `${letterByNumber(col)}${row + 1}`,
                coordinates: {
                    x: col,
                    y: row
                }
            });
        }
        gridData.push({
            cardRows: colCardData
        });
    }
    return gridData;
}

export const letterByNumber = (nVal: number) => String.fromCharCode(nVal + 65);

const locationToCoordinates = (location: string): Coordinates => {
    const x = location.charCodeAt(0) - 65;
    const y = parseInt(location.charAt(1)) - 1;
    return { x, y };
};

export const checkIfShipDestroyedComplex = (grid: GridData[], teams: Team[], answeredCard: CardData): boolean => {
    const affectedTeamName = answeredCard.shipTeam;
    const affectedTeam = teams.find((t) => t.name === affectedTeamName)!;
    const affectedCoordinates = locationToCoordinates(answeredCard.locationCode);
    const affectedShip = affectedTeam?.shipLocations.find(
        (ship) => BattleshipGenerator.getShipCoordinates(ship).indexOf(affectedCoordinates) > -1
    )!;
    const shipRemainingCoordinates = BattleshipGenerator.getShipCoordinates(affectedShip);
    remove(shipRemainingCoordinates, affectedCoordinates);

    let stillInPlay = false;
    shipRemainingCoordinates.forEach((c) => {
        stillInPlay = !grid[c.x].cardRows[c.y].answered || stillInPlay;
    });

    return !stillInPlay;
};

export const checkIfShipDestroyed = (grid: GridData[], answeredCard: CardData): boolean => {
    if (answeredCard.shipTeam) {
        const affectedCoordinates = locationToCoordinates(answeredCard.locationCode);
        const shipRemainingCoordinates = BattleshipGenerator.getShipCoordinates(answeredCard.ship!);
        remove(shipRemainingCoordinates, affectedCoordinates);

        let stillInPlay = false;
        shipRemainingCoordinates.forEach((c) => {
            stillInPlay = !grid[c.x].cardRows[c.y].answered || stillInPlay;
        });

        return !stillInPlay;
    }
    return false;
};
